import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AdminPermission } from '@mol-limo-reg/admin-api';
import { filter, map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AdminPermissionGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.profile$.pipe(
      filter((profile) => !!profile),
      map((profile) => {
        const permissions = profile!.permissions;
        if (!permissions) {
          return false;
        }
        const availablePaths = this.mapPermissionsToPaths(permissions);
        const currentPath = state.url;
        if (!availablePaths.includes(currentPath)) {
          this.router.navigate([availablePaths[0]]);
          return false;
        }

        return true;
      })
    );
  }

  private mapPermissionsToPaths(permissions: AdminPermission[]): string[] {
    return permissions.flatMap((permission) => {
      switch (permission) {
        case AdminPermission.CLAIMS_MANAGEMENT:
          return ['/claim-management'];
        case AdminPermission.ADMIN_MANAGEMENT:
          return ['/admins'];
        case AdminPermission.BLACKLIST_MANAGEMENT:
          return ['/blacklist'];
        case AdminPermission.RENTAL_MANAGEMENT:
          return ['/booking-management'];
        case AdminPermission.CAR_MANAGEMENT:
          return ['/manage-cars'];
        case AdminPermission.COPY_MANAGEMENT:
          return ['/copy-management'];
        case AdminPermission.STATION_MANAGEMENT:
          return ['/station-configurator'];
        default:
          return [];
      }
    });
  }
}
